<template>
  <div class="content">
    <p class="title">{{ isOwner === true ? '公司信息' : '用户信息'}}</p>
    <div class="info">
      <div class="info-left">
        <div class="logo">
          <img src="~@/assets/image/company-logo.png" alt="">
        </div>
        <div class="info-name">
          <p class="name">{{ companyName }}</p>
          <p class="tel">联系电话：{{ contactPhoneNumber }}</p>
        </div>
      </div>
      <div class="info-right">
        <div class="info-item" v-if="isOwner === true">
          <p class="item-title"> 场地数量 </p>
          <p class="item-number"> {{info.rentalNum}} </p>
        </div>
        <div class="info-item" v-if="isOwner === true">
          <p class="item-title"> 托管场地 </p>
          <p class="item-number"> {{info.trusteeshipRentalNum}} </p>
        </div>
        <div class="info-item" v-if="isOwner === true">
          <p class="item-title"> 托管物业 </p>
          <p class="item-number"> {{info.trusteeshipPropertyNum}} </p>
        </div>
        <div class="info-item" v-if="isOwner === true">
          <p class="item-title"> 当前托管率 </p>
          <p class="item-number"> {{info.trusteeshipRatio}} </p>
        </div>
        <div class="info-item" v-if="isOwner === false">
          <p class="item-title"> 租用物业 </p>
          <p class="item-number"> {{ quantityOfRentalProperties }} </p>
        </div>
        <div class="info-item" v-if="isOwner === false">
          <p class="item-title"> 钱包余额 </p>
          <p class="item-number"> {{ walletBalance }} </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'owner-info',
  props: {
    isOwner: {
      type: Boolean,
      default: true
    },
    info: {},
    companyName: String,
    contactPhoneNumber: String,
    quantityOfRentalProperties: Number,
    walletBalance: Number
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  color: #333;
  .title {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .info {
    display: flex;
    margin: 24px 0 0 0;
    .info-left {
      display: flex;
      border-right: 1px solid #ddd;
    }
    .info-right {
      display: flex;
      flex-wrap: wrap;
    }
    .info-left,
    .info-right {
      text-align: left;
      width: 50%;
      height: 240px;
      .logo {
        width: 50%;
        height: auto;
      }
    }
    .info-name {
      float: left;
      height: 100%;
      width: 50%;
      // padding: 18px;
      box-sizing: border-box;
      .name {
        font-size: 18px;
        font-weight: bold;
        margin: 12px 0;
      }
    }
    .info-item {
      width: 50%;
      height: 50%;
      text-align: center;
      .item-title {
        font-size: 18px;
        font-weight: bold;
        margin: 12px;
      }
      .item-number {
        font-size: 18px;
      }
    }
  }
}
</style>
